import work_surprise from './work_surprise';
import restuarant_problem from './restuarant_problem';
import vacation from './vacation';

const letters_en = [];
  letters_en.push({ name: 'Work Surprise', content:work_surprise });
  letters_en.push({ name: 'Restuarant Problem', content:restuarant_problem });
  letters_en.push({ name: 'Vacation Friend', content:vacation });

export default letters_en;